import { m } from 'framer-motion'
import { Theme, SxProps } from '@mui/material/styles'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { MotionContainer, varBounce } from 'src/components/animate'
import { useUserStore } from 'src/store/user'
import { DEFAULT_USER_PERMISSIONS } from 'src/types/user'
import { useAuthContext } from '../hooks'

type PermissionGuardProp = {
  hasContent?: boolean
  permission: string
  children: React.ReactNode
  sx?: SxProps<Theme>
}

export default function PermissionGuard({
  hasContent,
  permission,
  children,
  sx,
}: PermissionGuardProp) {
  const { user } = useUserStore()
  const { logout } = useAuthContext()

  if (user?.role === 'admin') {
    return <> {children} </>
  }

  const merged = {
    ...DEFAULT_USER_PERMISSIONS,
    ...(user?.permissions || {}),
  }
  if (!merged[permission]) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: 'center', ...sx }}>
        <m.div variants={varBounce().in}>
          <Typography variant='h3' paragraph>
            Permissão negada
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            Você não tem permissão para acessar este módulo
          </Typography>
        </m.div>

        <Button
          variant='contained'
          onClick={() => {
            window.location.href = '/auth/login'
            logout()
          }}
          sx={{ mt: 5 }}
        >
          Sair
        </Button>
      </Container>
    ) : null
  }

  return <> {children} </>
}
